import { Question } from "interfaces/question";
export const interviewLuisa: Question[] = [
  {
    id: 1,
    title:
      "Você começou fazendo covers no YouTube. Quais artistas da música pop mundial você escolheria para fazer covers de músicas suas e quais músicas seriam?",
    answer:
      "Gente, nunca me fizeram essa pergunta! Fui pega desprevenida! (risos) Mas acho que, na verdade, eu queria fazer músicas novas para a Ariana Grande, para a Beyoncé, para o Drake, para a Karol G e para a Rihanna. Ia amar!",
  },
  {
    id: 2,
    title:
      "Na sua opinião, quais são as cantoras mais poderosas do pop atualmente e por quê?",
    answer:
      "Eu acho que cada uma tem sua importância. Acho que o pop só é legal desse jeito porque tem muita gente fazendo, muitas cantoras poderosas e incríveis dando o seu melhor. O pop é um movimento que não se alimenta sozinho, por isso eu quero ver cada vez mais nomes do pop surgindo e brilhando.",
  },
  {
    id: 3,
    title:
      "Se você tivesse um #SQUAD de poderosas brasileiras, tipo como a Taylor Swift também tem, quem estaria nele?",
    answer: "Anitta, Pabllo Vittar, Pocah, Lexa, Rebecca, Ludmilla e IZA",
  },
  {
    id: 4,
    title: "Quais são os discos de música pop que você ouviu até dizer chega?",
    answer:
      "O Homecoming (2019), da Beyoncé, ao vivo. Aliás, ouço muitos discos ao vivo. Escutei muito o álbum da Karol G (KG0516, de 2021), que é reggaeton, mas não consigo não falar dele. Thank u, next (2019), da Ariana Grande, Anti (2016), da Rihanna. Também ouço tudo da Billie Eilish. Amo demais!",
  },
  {
    id: 5,
    title:
      "Cinco músicas mais rebolativas do universo pop? (Não vale escolher música sua, né, menina.)",
    answer:
      "Bola rebola, Tropkillaz, J Balvin, Anitta, Mc Zaac. Rainha da favela, Ludmilla. Sua cara, Major Lazer, Anitta, Pabllo Vittar. Deslizo e jogo, Rebecca, Pep Starling. Sapequinha, Lexa e MC Lan.",
  },
  {
    id: 6,
    title:
      "Se você fosse fazer uma apresentação no VMA, como seria o seu palco?",
    answer:
      "Dependeria muito do tipo de música que eu estivesse fazendo no momento. Mas, com certeza, faria uma coisa bem pop, bem dançante, bem grandiosa e muito visceral.",
  },
  {
    id: 7,
    title: "Qual diva pop você mais ama no mundo e por quê?",
    answer:
      "Difícil escolher uma só. Acho que todas elas contribuem de uma maneira muito única para a minha formação. Gosto muito da Beyoncé, da Rihanna, da Ariana Grande, da Lady Gaga. Talvez a Gaga seja uma das minhas maiores inspirações. Mas como deixar a Britney Spears de fora, né? Amo ela também. Amo a Christina Aguilera. É muita gente. Socorro!",
  },
  {
    id: 8,
    title:
      "O que tem por trás da magia da música pop? Por que você acha que ela move e comove tanta gente?",
    answer:
      "Sinto que o pop é maior do que a música pop em si. A cultura pop vai do mais superficial ao mais profundo. É uma linha de pensamento, é um jeito de viver a vida. Não é só o hit. É a vida.",
  },
];
